const fileInput = (() => {
  const init = () => {
    document.querySelectorAll('[data-file-trigger]').forEach(setupTrigger);
  };

  const setupTrigger = (btn) => {
    const wrapper = btn.closest('.file-input-wrapper');
    const input = wrapper.querySelector('input[type="file"]');
    const selected = wrapper.querySelector('[data-file-selected]');
    const nameEl = wrapper.querySelector('[data-file-name]');
    const removeBtn = wrapper.querySelector('[data-file-remove]');

    btn.addEventListener('click', () => input.click());

    input.addEventListener('change', () => {
      const file = input.files[0];
      if (!file) return;
      nameEl.textContent = file.name;
      selected.hidden = false;
    });

    removeBtn.addEventListener('click', () => {
      input.value = '';
      nameEl.textContent = '';
      selected.hidden = true;
    });
  };

  return { init };
})();

export { fileInput };
